var map = {
	"./__language": [
		"d5d5",
		7,
		"chunk-2d21e958"
	],
	"./__language.js": [
		"d5d5",
		7,
		"chunk-2d21e958"
	],
	"./en/legal-policies/legal-policies": [
		"becd",
		7,
		"chunk-2d21b4da"
	],
	"./en/legal-policies/legal-policies.js": [
		"becd",
		7,
		"chunk-2d21b4da"
	],
	"./export-language": [
		"69b3",
		7,
		"chunk-1976908c"
	],
	"./export-language.js": [
		"69b3",
		7,
		"chunk-1976908c"
	],
	"./import-language": [
		"2086",
		7,
		"chunk-dfa7a6ba"
	],
	"./import-language.js": [
		"2086",
		7,
		"chunk-dfa7a6ba"
	],
	"./km/legal-policies/legal-policies": [
		"113e",
		7,
		"chunk-2d0aa5a8"
	],
	"./km/legal-policies/legal-policies.js": [
		"113e",
		7,
		"chunk-2d0aa5a8"
	],
	"./language": [
		"9944",
		9
	],
	"./language.js": [
		"9944",
		9
	],
	"./zh/legal-policies/legal-policies": [
		"ecba",
		7,
		"chunk-2d230a53"
	],
	"./zh/legal-policies/legal-policies.js": [
		"ecba",
		7,
		"chunk-2d230a53"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "fa75";
module.exports = webpackAsyncContext;